import { FC, useMemo } from 'react';
import { useProgressionContext } from '../../contexts/progression_context';
import { useUserContext } from '../../contexts/user_context';

import './season_pass_page.css';

export const SeasonPassPage: FC = () => {
    const { xp } = useUserContext();
    const { seasons } = useProgressionContext();

    const current_season = useMemo(() => seasons[0], [seasons]);

    const current_tiers = useMemo(() => {
        if (!current_season || !current_season.pass?.tiers) return [];
        const data = current_season.pass.tiers;
        return data.map((tier, index) => {
            let prev_xp = data[index - 1]?.max_xp || 0;
            let progress = Math.min(100, ((xp - prev_xp) / (tier.max_xp - prev_xp)) * 100);
            return {
                tier_xp: tier.max_xp,
                progress: Math.min(Math.max(0, Math.round(progress)), 100),
            };
        });
    }, [current_season, xp]);

    return current_season ? (
        <div className='season-pass-page'>
            <div className='text-container'>
                <h2>🎉🏆 {current_season.name}</h2>
                <p>
                    Welcome to the Season Pass! Unlock exclusive rewards and amazing prizes as you progress through
                    the season. Complete challenges, climb the ranks, and claim your rewards before time runs out!
                    🎉🏆
                </p>
            </div>
            <div className='season-pass'>
                <h3 className='pass-name'>🎟️ Pass</h3>
                <div className='season-pass-tiers-wrap fog violet fog-right'>
                    {current_tiers.map(({ tier_xp, progress }, index) => (
                        <div className='season-pass-tier' key={index} data-earned={Number(progress === 100)}>
                            <b>Tier {index + 1}</b>
                            <div className='progress-wrap'>
                                <div className='progress' style={{ width: `${progress}%` }}></div>
                            </div>
                            <span>{tier_xp} Points</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    ) : null;
};
